import axios from 'axios';
import router from '@app/router/index.APP_TARGET';
import store from '@app/store';
import BPCMessageService from '@core/services/bpc-messages.service';
import AuthService from '@auth/services/auth.service';
import AuthorizationService from '@auth/services/authorization.service';

const bpcMessage = new BPCMessageService();

const authService = new AuthService();
const authorizationService = new AuthorizationService();
export default class BPCApiInterceptor {
  constructor() {
    axios.interceptors.request.use(
      function(config) {
        return new Promise(resolve => {
          if (store.getters['auth/isLoggedIn']) {
            // We need to know if the request is of type refresh token
            // because it could generate an infinite loop
            const isRefreshTokenQuery = config.headers?.BPC_Refresh_token_request;
            if (
              authService.hasTokenExpired() &&
              authService.hasRefreshToken() &&
              !isRefreshTokenQuery
            ) {
              // console.log('authService.hasTokenExpired() && authService.hasRefreshToken()');
              authService.userRefreshToken().then((token: string) => {
                // console.log('authService.userRefreshToken().then(()', token);
                config.headers.Authorization = `Bearer ${token}`;
                resolve(config);
              });
            } else {
              // console.log('ELSE authService.hasTokenExpired() && authService.hasRefreshToken()');

              config.headers.Authorization = `Bearer ${store.getters['auth/authToken']}`;
              resolve(config);
            }
          } else {
            // console.log('ELSE store.getters[auth/isLoggedIn]');
            resolve(config);
          }

          if (store.getters['auth/userLang']) {
            config.headers['BPC-Language'] = `${store.getters['auth/userLang']}`;
          }
        });
      },
      function(err) {
        return Promise.reject(err);
      },
    );

    axios.interceptors.response.use(
      function(response) {
        // Interceptors for the response
        return response;
      },
      function(error) {
        if (error.response && error.response.status == '500') {
          bpcMessage.showErrorMessage({ text: 'global.generic.server_error' });
        } else if (error.response && error.response.status == '401') {
          if (!store.getters['auth/refreshToken']) {
            bpcMessage.showErrorMessage({ text: 'global.auth.must_login' });
            const redirect = {
              fullPath: router.currentRoute.fullPath,
            };
            const loginRoute = authorizationService.getAuthLoginRoute(redirect);
            router.push(loginRoute);
          } else {
            authService.handlerAuthError();
          }
        } else if (error.response && error.response.status == '403') {
          bpcMessage.showErrorMessage({ text: error.response.data.message });
        } else if (error.response && error.response.status == '405') {
          bpcMessage.showErrorMessage({ text: error.response.data.message }); // Custom messages
        } else if (error.response && error.response.status == '420') {
          bpcMessage.showWarningMessage({ text: error.response.data.message }); // Custom messages
        }
        throw error;
      },
    );
  }
}
